import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { useTimezone } from './timezone-context';

dayjs.extend(timezone);

export function TimezoneToggle() {
  const { mode, setMode } = useTimezone();

  const localTzName = dayjs.tz.guess();

  return (
    <Stack direction="row" justifyContent="flex-end">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={mode}
        onChange={(_, value) => {
          if (!value) return;

          setMode(value);
        }}
      >
        <ToggleButton
          value="local"
          sx={{
            px: 1.5,
            py: 0.25,
            fontSize: 11,
            lineHeight: 1.5,
          }}
        >
          {localTzName}
        </ToggleButton>

        <ToggleButton
          value="utc"
          sx={{
            px: 1.5,
            py: 0.25,
            fontSize: 11,
            lineHeight: 1.5,
          }}
        >
          UTC
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
